import { render, staticRenderFns } from "./top-insurers.vue?vue&type=template&id=7c6d65ae&scoped=true"
import script from "./top-insurers.vue?vue&type=script&lang=js"
export * from "./top-insurers.vue?vue&type=script&lang=js"
import style0 from "./top-insurers.vue?vue&type=style&index=0&id=7c6d65ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6d65ae",
  null
  
)

export default component.exports